<common-mojo-expandable-card
  *ngIf="showCard; else talentPoolView"
  [expandable]="expandable"
  (toggle)="toggleCard($event)"
>

  <ng-template-outlet *ngTemplateOutlet="educationContent">
  </ng-template-outlet>

</common-mojo-expandable-card>

<ng-template #talentPoolView>
  <mojo-expandible-card
    [expandable]="expandable"
    (toggle)="toggleCard($event)"
  >
    <ng-template-outlet *ngTemplateOutlet="educationContent">
    </ng-template-outlet>
  </mojo-expandible-card>
</ng-template>

<ng-template #educationContent>

  <div
    class="education-header"
    [ngClass]="{'font-size-talent-pool': !showCard}"
  >Education</div>
  <div class="education-list-wrapper">
    <div
      *ngFor="let education of displayedEducations; trackBy: trackElement"
      class="education-item"
      [ngClass]="{'font-size-talent-pool': !showCard}"
    >
      <div class="degree">
        {{ education?.degree}}
        <span
          *ngIf="education?.majorCourse">{{(', ' + education?.majorCourse)}}</span>
      </div>
      <div class="school-name">
        {{ education?.schoolName}}
      </div>
      <div class="school-location comma-separate">
        <span>{{ education?.schoolLocation?.city }}</span>
        <span>{{ education?.schoolLocation?.state }}</span>
        <span>{{ education?.schoolLocation?.country }}</span>
      </div>
      <div
        *ngIf="!!education?.startDate && !!education?.endDate"
        class="dates"
      >
        {{ education?.startDate | daysPassed: true }}
        - {{ education?.endDate | daysPassed: true }}
      </div>
    </div>
  </div>

</ng-template>
